<template>
  <div class="bg-gray-100 p-4 rounded relative w-full">
    <button
      class="w-full bg-white border border-gray-300 text-gray-700 font-medium py-2 px-4 rounded hover:bg-gray-50"
      @click="toggleDropdown"
    >
      Other Actions
    </button>

    <div
      v-show="isOpen"
      class="absolute right-0 mt-2 w-full bg-white border border-gray-300 rounded shadow-md z-10"
    >
      <button class="w-full text-left px-4 py-2 hover:bg-gray-100">
        Assign to Someone Else
      </button>
      <button class="w-full text-left px-4 py-2 hover:bg-gray-100">
        Decline to Sign
      </button>
      <button class="w-full text-left px-4 py-2 hover:bg-gray-100">
        Comment
      </button>
      <button class="w-full text-left px-4 py-2 hover:bg-gray-100">
        Finish Later
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherActions',
  data () {
    return {
      isOpen: false
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown () {
      this.isOpen = !this.isOpen
    },
    handleClickOutside (e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false
      }
    }
  }
}
</script>
